export const PLATFORMS = ['whatsapp', 'signal'];
export const TRANSLATION_PROVIDERS = ['google', 'deepl'];
export const DEEPL_MODEL_TYPES = [
    'latency_optimized',
    'quality_optimized',
    'prefer_quality_optimized'
];
export function isPlatform(value) {
    return typeof value === 'string' && PLATFORMS.includes(value);
}
export function isTranslationProvider(value) {
    return typeof value === 'string'
        && TRANSLATION_PROVIDERS.includes(value);
}
export const ADMIN_PERMISSIONS = [
    'overview.read',
    'users.read',
    'users.write',
    'licenses.read',
    'licenses.write',
    'devices.read',
    'devices.write',
    'translation.read',
    'translation.write',
    'usage.read',
    'releases.read',
    'releases.write',
    'audit.read',
    'system.read'
];
//# sourceMappingURL=index.js.map